/**
 * @author caijianjia
 * @date 2020/3/15 3:09 下午
 */
import * as utils from './utils'
const _ = require('lodash')

const GlobalPlugin = {}
GlobalPlugin.install = (Vue) =>{
  Vue.prototype.$utils = utils
  Vue.prototype.$_ = _
}
export default GlobalPlugin



// WEBPACK FOOTER //
// ./src/utils/globalUtil.js